import { render } from "./UploadFailed.vue?vue&type=template&id=447d48dc&ts=true"
import script from "./UploadFailed.vue?vue&type=script&lang=ts"
export * from "./UploadFailed.vue?vue&type=script&lang=ts"

import "./UploadFailed.vue?vue&type=style&index=0&id=447d48dc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__